import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";
import {ADD_VIMEO_ID} from "./actionTypes";

export function updateVimeoVideoSuccess(vimeo) {
    return {type: types.UPDATE_VIMEO_VIDEO, vimeo};
}

export function deleteVimeoVideoSuccess(id) {
    return {type: types.DELETE_VIMEO_VIDEO, id};
}

export function getVimeoDataSuccess(id, vimeo) {
    return {type: types.GET_VIMEO_SUCCESS, id, vimeo}
}

export function addVimeoId(id, companyId) {
    return function (dispatch) {
        return PrivateAPIResource.create('vimeos', {
            'vimeoId': id,
            'companyId': companyId,
        })
            .then(() => {
                dispatch(() => {return {type: types.ADD_VIMEO_ID}});
            })
            .catch(error => {
                return Promise.resolve(error);
            })
    }
}

export function getVimeoData(id) {
    return function (dispatch) {
        return fetch(`https://api.vimeo.com/videos/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer '+ VIMEO_TOKEN,
            }
        }).then(response => {
            return response.json();
        }).then(data => {
            dispatch(getVimeoDataSuccess(id, data));
            return data;
        }
        ).catch(error => {
            return Promise.reject(error);
        });
    }
}

export function updateVimeoVideo(id, data) {
    return function (dispatch) {
        return fetch(`https://api.vimeo.com/videos/${id}`, {
            method: 'PATCH',
            headers: {
                'Authorization': 'Bearer '+ VIMEO_TOKEN,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(response => {
            dispatch(updateVimeoVideoSuccess(response));
        }).catch(error => {
            return Promise.resolve(error);
        });
    }
}

export function deleteVimeoVideo(id) {
    return function (dispatch) {
        return fetch(`https://api.vimeo.com/videos/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer '+ VIMEO_TOKEN,
                'Content-Type': 'application/json',
            }
        }).then(() => {
            dispatch(deleteVimeoVideoSuccess(id));
        }).catch(error => {
            return Promise.resolve(error);
        });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/vimeoActions.js